// NBA team metadata keyed by the team names stored in the database.
// `accent` is a variant of the team's colors that stays legible on a dark
// background (several primaries are near-black navies).
export const TEAM_INFO = {
  'Atlanta Hawks': { acronym: 'ATL', id: 1610612737, accent: '#e8484c' },
  'Boston Celtics': { acronym: 'BOS', id: 1610612738, accent: '#2fb06b' },
  'Brooklyn Nets': { acronym: 'BKN', id: 1610612751, accent: '#d4d4d4' },
  'Charlotte Hornets': { acronym: 'CHA', id: 1610612766, accent: '#14a7b8' },
  'Chicago Bulls': { acronym: 'CHI', id: 1610612741, accent: '#e8344f' },
  'Cleveland Cavaliers': { acronym: 'CLE', id: 1610612739, accent: '#c9506e' },
  'Dallas Mavericks': { acronym: 'DAL', id: 1610612742, accent: '#3b8fe4' },
  'Denver Nuggets': { acronym: 'DEN', id: 1610612743, accent: '#fec524' },
  'Detroit Pistons': { acronym: 'DET', id: 1610612765, accent: '#e2394c' },
  'Golden State Warriors': { acronym: 'GSW', id: 1610612744, accent: '#ffc72c' },
  'Houston Rockets': { acronym: 'HOU', id: 1610612745, accent: '#e8344f' },
  'Indiana Pacers': { acronym: 'IND', id: 1610612754, accent: '#fdbb30' },
  'LA Clippers': { acronym: 'LAC', id: 1610612746, accent: '#4a7fe0' },
  'Los Angeles Lakers': { acronym: 'LAL', id: 1610612747, accent: '#a274e0' },
  'Memphis Grizzlies': { acronym: 'MEM', id: 1610612763, accent: '#7d9bd6' },
  'Miami Heat': { acronym: 'MIA', id: 1610612748, accent: '#e2335a' },
  'Milwaukee Bucks': { acronym: 'MIL', id: 1610612749, accent: '#4cb072' },
  'Minnesota Timberwolves': { acronym: 'MIN', id: 1610612750, accent: '#78be20' },
  'New Orleans Pelicans': { acronym: 'NOP', id: 1610612740, accent: '#c8a95e' },
  'New York Knicks': { acronym: 'NYK', id: 1610612752, accent: '#f58426' },
  'Oklahoma City Thunder': { acronym: 'OKC', id: 1610612760, accent: '#3aa3eb' },
  'Orlando Magic': { acronym: 'ORL', id: 1610612753, accent: '#2d9de6' },
  'Philadelphia 76ers': { acronym: 'PHI', id: 1610612755, accent: '#3d85e6' },
  'Phoenix Suns': { acronym: 'PHX', id: 1610612756, accent: '#ea6a2a' },
  'Portland Trail Blazers': { acronym: 'POR', id: 1610612757, accent: '#e8484c' },
  'Sacramento Kings': { acronym: 'SAC', id: 1610612758, accent: '#9a70d0' },
  'San Antonio Spurs': { acronym: 'SAS', id: 1610612759, accent: '#c4ced4' },
  'Toronto Raptors': { acronym: 'TOR', id: 1610612761, accent: '#e8344f' },
  'Utah Jazz': { acronym: 'UTA', id: 1610612762, accent: '#f9a01b' },
  'Washington Wizards': { acronym: 'WAS', id: 1610612764, accent: '#e8344f' },
}

const UNKNOWN_TEAM = { acronym: 'UNK', id: null, accent: '#9aa0a6' }

export const teamInfo = name => TEAM_INFO[name] || UNKNOWN_TEAM

export const teamLogo = name => {
  const { id } = teamInfo(name)
  return id ? `/logos/${id}.svg` : null
}
